import React, { useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

// import '../css/index.css';
import { Typography } from "@material-ui/core";

interface Props {
  onClickApply: (timeStamp: Number) => void;
}
const timeRegex = /^\d{2}:\d{2}$/;

const ReplaySidebar = (props: Props) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toLocaleDateString("en-US")
  );
  const [HourAndMin, setHourAndMin] = useState<any>("");

  const styles = useStyles();

  const onDateChange = (date, dateString) => {
    setSelectedDate(dateString);
  };

  const onChangeHourAndMin = (e) => {
    setHourAndMin(e.target.value);
  };

  const onClickApply = () => {
    if (!selectedDate || !HourAndMin) {
      alert("please choose the valid options");
    }
    if (HourAndMin.match(timeRegex)) {
      const timeStamp = new Date(`${selectedDate} ${HourAndMin}`).getTime();
      props.onClickApply(timeStamp);
    } else {
      alert("Time format must match hh:mm format. Example 14:20");
    }
  };

  return (
    <div className={styles.container}>
      <Typography className={styles.labelStyle}>Select Date</Typography>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          value={selectedDate}
          onChange={onDateChange}
          animateYearScrolling
          format="yyyy/MM/dd"
          placeholder="YYYY/MM/DD"
          disableFuture
          style={{ width: "100%", fontSize: "15px" }}
          DialogProps={{
            className: styles.dialogStyle,
          }}
          inputProps={{
            style: { fontSize: "15px", width: "100%" },
          }}
        />
      </MuiPickersUtilsProvider>

      <div>
        <Typography className={styles.labelStyle}>
          Enter Hour and Minute -
        </Typography>
        <Typography  className={styles.timeStyle}>
          24HR FORMAT
          </Typography>    
        <Input
          autoComplete={"off"}
          className={styles.minInput}
          name={"Enter Hour and Minute"}
          value={HourAndMin}
          onChange={onChangeHourAndMin}
          placeholder="HH:MM"
        />
      </div>
      <Button
        variant="contained"
        color="primary"
        className={styles.applyBtn}
        onClick={onClickApply}
      >
        Apply
      </Button>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      backgroundColor: theme.palette.background.default,
      width: 200,
      paddingBottom: 10,
      paddingRight: 10,
    },
    minInput: {
      fontSize: "15px",
      width: "100%",
    },
    applyBtn: {
      marginTop: 15,
      fontSize: "13px",
      fontFamily: "Barlow",
    },
    labelStyle: {
      marginTop: 15,
      fontSize: "15px",
    },
    timeStyle: {
      fontSize: "10px",
    },
    dialogStyle: {
      fontSize: "16px",
      fontWeight: 500,

      "& .MuiTypography-body2": {
        fontSize: "16px",
        fontWeight: 500,
      },
      "& .MuiButton-label": {
        fontSize: "15px",
      },
      "& .MuiTypography-caption": {
        fontSize: "16px",
        fontWeight: 500,
      },
      "& .MuiTypography-subtitle1": {
        fontSize: "15px",
        fontWeight: 500,
      },
    },
  };
});

export default ReplaySidebar;
